var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.09091 9.54554L1.90909 6.36373C1.55764 6.01227 0.987817 6.01227 0.636364 6.36373C0.28491 6.71518 0.28491 7.285 0.636364 7.63645L4.3838 11.3839C4.77433 11.7744 5.40749 11.7744 5.79802 11.3839L15.3636 1.81827C15.7151 1.46682 15.7151 0.896997 15.3636 0.545543C15.0122 0.194089 14.4424 0.194089 14.0909 0.545543L5.09091 9.54554Z",
    fill: "#27AE60"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.5654659c4da64c6075aa5537f0fab651.svg";
export { ForwardRef as ReactComponent };